import axiosInstance from "../axiosInstance";

const BASE = "/settings/user-access";

export const getUserAccessEmployees = async () => {
  const res = await axiosInstance.get(`${BASE}/employees`);
  return res.data;
};

export const getUserAccessSummary = async (employeeId) => {
  const res = await axiosInstance.get(`${BASE}/${employeeId}/summary`);
  return res.data;
};

export const assignUserAccess = async (employeeId, payload) => {
  const res = await axiosInstance.put(`${BASE}/${employeeId}`, payload);
  return res.data;
};

export const exportUserAccess = async (employeeId, format = "xlsx") => {
  const res = await axiosInstance.get(
    `${BASE}/${employeeId}/export?format=${format}`,
    { responseType: "blob" }
  );
  return res.data;
};
